export const LASER_NOTE_MAX_LENGTH = 300;
